import React from 'react';
import { Link } from 'react-router-dom';
import { Crown, CheckCircle, Sparkles, ArrowRight, Mail, PartyPopper } from 'lucide-react';

const PaymentSuccess = () => {
  return (
    <div className="min-h-screen bg-black flex items-center justify-center px-4" style={{
      background: 'linear-gradient(180deg, #000000 0%, #1a1a1a 50%, #000000 100%)'
    }}>
      {/* Confetti effect */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        {[...Array(20)].map((_, i) => (
          <div
            key={i}
            className="absolute animate-pulse"
            style={{
              left: `${Math.random() * 100}%`,
              top: `${Math.random() * 100}%`,
              animationDelay: `${Math.random() * 2}s`,
              opacity: 0.3
            }}
          >
            <Sparkles className="w-4 h-4 text-[#E10600]" />
          </div>
        ))}
      </div>

      <div className="max-w-lg w-full text-center relative z-10">
        {/* Logo */}
        <div className="mb-8">
          <div className="w-20 h-20 mx-auto mb-4 rounded-full flex items-center justify-center" style={{
            background: 'linear-gradient(135deg, #E10600 0%, #DC143C 100%)',
            boxShadow: '0 0 40px rgba(225, 6, 0, 0.4)'
          }}>
            <img src="/popcrown-crown-red.png" alt="" aria-hidden="true" className="w-10 h-10 object-contain" />
          </div>
          <h1 className="text-2xl font-bold text-white tracking-wider">POPCROWN</h1>
        </div>

        {/* Success Card */}
        <div className="p-8 rounded-2xl mb-6" style={{
          background: 'linear-gradient(135deg, rgba(34, 197, 94, 0.15) 0%, rgba(34, 197, 94, 0.05) 100%)',
          border: '2px solid rgba(34, 197, 94, 0.5)',
          boxShadow: '0 0 60px rgba(34, 197, 94, 0.2)'
        }}>
          <div className="flex justify-center mb-4">
            <div className="w-16 h-16 rounded-full bg-green-500/20 flex items-center justify-center">
              <CheckCircle className="w-10 h-10 text-green-500" />
            </div>
          </div>
          
          <h2 className="text-3xl font-bold text-white mb-2">Welcome to the Family!</h2>
          <p className="text-green-400 text-lg font-semibold mb-4 inline-flex items-center gap-2">Payment Successful <PartyPopper className="w-5 h-5" strokeWidth={2} aria-hidden="true" /></p>
          
          <p className="text-gray-300 mb-6">
            Thank you for joining the PopCrown Community! You're now part of something special.
          </p>

          <div className="p-4 rounded-xl mb-6" style={{ background: 'rgba(225, 6, 0, 0.1)', border: '1px solid rgba(225, 6, 0, 0.3)' }}>
            <h3 className="text-[#E10600] font-bold mb-2 flex items-center justify-center gap-2">
              <Mail className="w-5 h-5" /> Next Step
            </h3>
            <p className="text-gray-300 text-sm">
              Create your account using the <strong>same email address</strong> you used for payment to activate your membership.
            </p>
          </div>

          <a 
            href="https://members.popcrownofficial.com/auth/sign-up"
            className="inline-flex items-center justify-center gap-3 w-full py-4 px-6 rounded-xl font-bold text-lg transition-all hover:scale-105"
            style={{
              background: 'linear-gradient(135deg, #E10600 0%, #8B0000 100%)',
              color: '#000',
              boxShadow: '0 4px 20px rgba(225, 6, 0, 0.4)'
            }}
            data-testid="create-account-btn"
          >
            Create Your Account <ArrowRight className="w-5 h-5" />
          </a>

          <p className="text-gray-400 text-sm mt-4">
            Click the button above when you're ready
          </p>
        </div>

        {/* What's included reminder */}
        <div className="p-6 rounded-xl" style={{ background: 'rgba(255, 255, 255, 0.05)', border: '1px solid rgba(255, 255, 255, 0.1)' }}>
          <h3 className="text-white font-semibold mb-3">Your Membership Includes:</h3>
          <div className="grid grid-cols-2 gap-2 text-sm text-gray-400">
            <div className="flex items-center gap-2">
              <CheckCircle className="w-4 h-4 text-green-500" />
              <span>Full Members Area</span>
            </div>
            <div className="flex items-center gap-2">
              <CheckCircle className="w-4 h-4 text-green-500" />
              <span>Annie AI Assistant</span>
            </div>
            <div className="flex items-center gap-2">
              <CheckCircle className="w-4 h-4 text-green-500" />
              <span>Community Feed</span>
            </div>
            <div className="flex items-center gap-2">
              <CheckCircle className="w-4 h-4 text-green-500" />
              <span>Quiz & Leaderboard</span>
            </div>
            <div className="flex items-center gap-2">
              <CheckCircle className="w-4 h-4 text-green-500" />
              <span>Exclusive Content</span>
            </div>
            <div className="flex items-center gap-2">
              <CheckCircle className="w-4 h-4 text-green-500" />
              <span>Ad-Free Experience</span>
            </div>
          </div>
        </div>

        {/* Footer */}
        <p className="text-gray-600 text-xs mt-8">
          Questions? Contact us at <a href="mailto:support@popcrownofficial.com" className="text-[#E10600] hover:underline">support@popcrownofficial.com</a>
        </p>

        <Link to="/" className="inline-block mt-4 text-gray-500 text-sm hover:text-white transition-colors">
          ← Back to Homepage
        </Link>
      </div>
    </div>
  );
};

export default PaymentSuccess;
